import React, { useState, useRef, useEffect } from 'react';
import {
  arrayOf,
  oneOfType,
  func,
  shape,
  string,
  bool,
  element,
  node,
} from 'prop-types';
import S from './style';

function Dropdown({ options, triggerContent, onSelect, openRight }) {
  const [open, setOpen] = useState(false);
  const wrapperReference = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        wrapperReference.current &&
        !wrapperReference.current.contains(event.target)
      ) {
        setOpen(false);
      }
    }

    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  const handleClick = (item) => {
    onSelect(item);
    setOpen(false);
  };

  return (
    <S.Trigger ref={wrapperReference}>
      {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
      <div onClick={() => setOpen(!open)}>{triggerContent}</div>

      <S.Dropdown isOpen={open} openRight={openRight}>
        {options.map((item) => (
          <S.DropdownItem key={item.value} onClick={() => handleClick(item)}>
            {item.icon &&
              (typeof item.icon === 'string' ? (
                <S.DropdownItemIcon src={item.icon} alt={item.label} />
              ) : (
                <S.DropdownItemIconElement>
                  {item.icon}
                </S.DropdownItemIconElement>
              ))}
            <S.DropdownItemLabel>{item.label}</S.DropdownItemLabel>
          </S.DropdownItem>
        ))}
      </S.Dropdown>
    </S.Trigger>
  );
}

Dropdown.propTypes = {
  options: arrayOf(
    shape({
      label: string.isRequired,
      value: string.isRequired,
      icon: oneOfType([string, element]),
    })
  ).isRequired,
  triggerContent: node.isRequired,
  onSelect: func.isRequired,
  openRight: bool,
};

export default Dropdown;
